<template>
  <div class="landingContentDiv">
    <main>
      <landing-nav-bar/>
      <div style="height: 100vh;" class="flex flex-column items-center">
        <div class="flex flex-column items-center centerItem h-100 w-100 mainPage">
          <div class="mainTitle">
            <h1 class="titleText ttu music">{{ $t("landing.music") }}</h1>
            <h3 class="titleText ttu">{{ $t("landing.title") }}</h3>
          </div>
          <div class="Texto">
            <h3 class="h3">{{ $t("landing.description.t1") }}</h3>
            <h3 class="h3">{{ $t("landing.description.t2") }}</h3>
            <h3 class="h3">{{ $t("landing.description.t3") }}</h3>
          </div>
          <div class="buttonContainerLanding flex-column items-center">
            <p class="Texto2">{{ $t("landing.leyend") }}</p>
            <div class="flex landingButtons">
                <router-link class="btnPildoraLeft"
                              title="Oyendo"
                              :to="{name: 'oyendo'}"
                >{{ $t("landing.button1") }}</router-link>
                <router-link class="btnPildoraRigth"
                              title="Creando"
                              :to="{name: 'creando'}"
                >{{ $t("landing.button2") }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100">
        <home-footer/>
      </div>
      <payment-modal></payment-modal>
    </main>
  </div>
</template>

<script>
  import consts from '@/consts'
  import DirectLinkModal from '@/components/modals/provider/DirectLinkModal.vue'
  import ProviderLink from '@/components/providerLink/ProviderLink.vue'
  import {mapActions, mapGetters} from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import HomeFooter from '@/components/home/HomeFooter.vue'
  import LandingNavBar from '@/components/Landing/LandingNavBar.vue'
  import { getInstance } from '@/auth/index'
  import PaymentModal from '@/components/modals/PaymentModal.vue'

  export default {
    name: 'landing',
    components: {
      ProviderLink,
      DirectLinkModal,
      FontAwesomeIcon,
      HomeFooter,
      LandingNavBar,
      PaymentModal
    },
    data () {
      return {
        userFromLandingMK: false
      }
    },
    created () {
      if (this.$route.query.referredCode) {
        localStorage.setItem('referredCode', this.$route.query.referredCode)
      }
      let provider = this.$route.query.provider
      this.getPricing()
      this.userFromLandingMK = localStorage.getItem('userFromLandingMK')
      let shareTrackId = this.$route.query.track_id
      if (shareTrackId) {
        localStorage.setItem('shareTrackId', shareTrackId)
        this.setIsShareTrack(true)
      }
      let sharePlayListId = this.$route.query.playlist_id
      if (sharePlayListId) {
        localStorage.setItem('sharePlayListId', sharePlayListId)
      }
      let qrArtistId = this.$route.query.artist_id
      if (qrArtistId) {
        localStorage.setItem('qrArtistId', qrArtistId)
      }
      this.providerLogin()
      if (provider === null || !provider) {
        if (this.userFromLandingMK === false || this.userFromLandingMK === null || !this.userFromLandingMK) {
          if (this.authToken || (shareTrackId !== null && shareTrackId !== undefined)) {
            if (shareTrackId !== null && shareTrackId !== undefined) {
              this.goToHome()
            } else {
              this.checkUser().then(i => {
                this.goToHome()
              })
            }
          }
        } else {
          if (this.authToken) {
            this.checkUser().then(i => {
              this.$router.push({path: '/paymentsMk'})
            })
          }
        }
      }
      window.onpopstate = this.onpopstate
    },
    beforeRHomeFooterouteUpdate (to, from, next) {
      let matched = false
      for (const matchedRoute of to.matched) {
        if (matchedRoute.name === 'artist') {
          next(false)
          this.getArtist(to.params.id).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
          this.getArtistTracks(to.params.id).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
          this.getArtistPlaylists(to.params.id).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
          this.openProfile()
          history.pushState({}, null, to.path)
          matched = true
        }
      }
      // close sidebar if route change
      if (!matched) {
        this.closeProfile()
        next()
      }
    },
    beforeRouteEnter (to, from, next) {
      // Open sidebar if artist route is requested
      for (const matchedRoute of to.matched) {
        if (matchedRoute.name === 'artist') {
          next((vm) => {
            vm.$store.dispatch('artist/getArtist', to.params.id).catch((e) => {
              vm.$toasted.show(vm.getters['artist/error'].message, {type: 'error'})
            })
            vm.$store.dispatch('artist/getArtistTracks', to.params.id).catch((e) => {
              vm.$toasted.show(vm.getters['artist/error'].message, {type: 'error'})
            })
            vm.$store.dispatch('artist/getArtistPlaylists', to.params.id).catch((e) => {
              vm.$toasted.show(vm.getters['artist/error'].message, {type: 'error'})
            })
            if (vm.$store.getters['user/isLoggedIn']) {
              vm.$store.dispatch('user/getMyVotes').catch((e) => {
                vm.$toasted.show(vm.getters['user/error'].message, {type: 'error'})
              })
            }
            vm.$store.dispatch('artist/openProfile')
          })
        }
      }

      if (typeof to.query.login !== 'undefined') {
        next((vm) => {
          vm.$modal.show('login-modal')
        })
      } else if (typeof to.query.signup !== 'undefined') {
        next((vm) => {
          vm.$modal.show('signup-modal')
        })
      } else if (typeof to.query.subscription !== 'undefined') {
        next((vm) => {
          vm.$modal.show('subscription-modal')
        })
      } else if (typeof to.query.track_id !== 'undefined') {
        next((vm) => {
          vm.$http.get(consts.API_BASE_URL + `/tracks/get/${to.query.track_id}`).then(res => {
            let track = res.body.data[0]
            if (track.length) {
              // vm.$store.dispatch('player/setPlaylist', track)
              // vm.$store.dispatch('player/playFirstTrack')
            }
          })
        })
      } else {
        next()
      }
    },
    methods: {
      ...mapActions('user', [
        'checkUser',
        'loginByMsisdn',
        'loginAuth'
      ]),
      ...mapActions('artist', [
        'getArtist',
        'getArtistTracks',
        'getArtistPlaylists',
        'openProfile',
        'closeProfile'
      ]),
      ...mapActions('user', [
        'loginByMsisdn'
      ]),
      ...mapActions('pricing', [
        'getPricing'
      ]),
      ...mapActions('player', [
        'setIsShareTrack'
      ]),
      providerLogin () {
        if (this.$route.query.xmsisdn) {
          let provider = this.$route.query.provider ? this.$route.query.provider : 'movistar'
          let providerCountry = this.$route.query.country ? this.$route.query.country : 'ARG'
          localStorage.setItem('providerCountry', providerCountry)
          this.loginByMsisdn({msisdn: this.$route.query.xmsisdn, provider: provider, country: providerCountry, enc: true}).then((e) => {
          }).catch(() => {
          })
        }
      },
      onpopstate (event) {
        // when the state is stored by `beforeRouteUpdate` event, the key is null
        if (this.isProfileOpen && event.state.key !== undefined) {
          this.closeProfile()
        }
      },
      goToHome () {
        var tId = localStorage.getItem('shareTrackId')
        var aId = localStorage.getItem('qrArtistId')
        var pId = localStorage.getItem('sharePlayListId')
        let rc = localStorage.getItem('referredCode')
        if (tId && tId !== null && tId !== undefined && tId !== '') {
          this.$router.push({path: '/home?track_id=' + tId})
        } if (pId && pId !== null && pId !== undefined && pId !== '') {
          this.$router.push({path: '/home?playlist_id=' + pId})
        } else if (aId && aId !== null && aId !== undefined && aId !== '') {
          this.$router.push({path: '/artists/' + aId + '/tracks'})
        } else if (rc) {
          this.$router.push({path: '/home?referredCode=' + rc})
        } else {
          this.$router.push({path: '/home'})
        }
      },
      scrollToTop () {
        window.scrollTo(0, 0)
      }
    },
    computed: {
      ...mapGetters('artist', [
        'isProfileOpen',
        'error'
      ]),
      ...mapGetters('user', [
        'authToken',
        'msisdn',
        'provider',
        'user'
      ])
    },
    mounted () {
      const authService = getInstance()
      var that = this
      authService.$watch('loading', loading => {
        if (loading === false) {
          return test(authService.user)
        }
      })
      if (this.authToken || this.user) {
        if (that.userFromLandingMK === false || that.userFromLandingMK === null || !that.userFromLandingMK) {
          this.checkUser().then(i => {
            this.goToHome()
          })
        } else {
          that.$router.push({path: '/paymentsMk'})
        }
      }
      const test = function (user) {
        if (user !== undefined) {
          that.loginAuth(user).then(() => {
            if (that.userFromLandingMK === false || that.userFromLandingMK === null || !that.userFromLandingMK) {
              that.goToHome()
            } else {
              that.$router.push({path: '/paymentsMk'})
            }
          })
        }
      }
      if (this.msisdn) {
        this.loginByMsisdn({msisdn: this.msisdn, provider: this.provider, enc: true, isValidation: true})
      }
      this.scrollToTop()
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Montserrat Black';
    src: url('~@/assets/fonts/new_landing/Montserrat-Black.otf');
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat Bold';
    src: url('~@/assets/fonts/new_landing/Montserrat-Bold.otf');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    src: url('~@/assets/fonts/Humnst777-Blk-BT-Black-Italic.ttf') format('truetype');
  }

  .mainPage {
    background-image: url('~@/assets/Landing/nueva_landing/auriculares.jpg');
    font-family: 'Montserrat Black';
    margin: 48px 0px 0px 0px;
    background-size: cover;
    background-position: center;
    line-height: initial;
  }

  .h3 {
    margin: 0px;
  }

  .m-t {
    margin-top: 25vh;
  }

  .VueCarousel-navigation-button{
    color: $text-color !important;
  }


  .landingContentDiv{
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #fff;
    background-color: #393839;
    height: calc(100vh - 3em - 58px);
  }
  .Texto{
    font-family: 'Montserrat Bold';
    text-align: center;
    font-size: 20px;
    margin-bottom: 0px;
    margin-top: 225px;
    text-shadow: 5px 5px 5px #000;
  }
  .Texto2{
    text-align: center;
    font-size: 25px;
    margin-top: 55px;
    margin-bottom: 0px;
  }

  .titleText{
    font-size: 75px;
    font-weight: bold;
    text-align: center;
    margin: 0px;
    position: relative;
    top: 25px;
    text-shadow: 5px 5px 5px #000;
  }

  .music {
    font-size: 100px;
  }

  .centerItem{
    width: 100%;
    height: 100%;
    background-color: black;
    margin-top: 48px;
  }
  .buttonContainerLanding{
    margin-top: 0px;
    margin-bottom: 30px;
    position: relative;
    top: 45px;
  }

  .btnPildoraLeft{
    padding-bottom: 8px;
    padding-top: 8px;
    font-size: 20px;
      width: 170px;
      height: 20%;
      border-radius: 35px 35px 35px 35px;
      margin-right: 50px;
      outline: 0;
      border-width: 1px;
      border-color: #8600CF;
      background-color: #8600CF;
      color: #fff;
      outline-offset: 1px;
      text-decoration: none;
      overflow: hidden;
      text-align: center;
      font-family: 'Montserrat Bold' !important;
  }
  .btnPildoraLeft:active,.btnPildoraLeft:hover{
    background-color: #fff !important;
    color: #8600CF !important;
  }

  .btnPildoraRigth{
    padding-bottom: 8px;
    padding-top: 8px;
    font-size: 20px;
      width: 170px;
      height: 20%;
      border-radius: 35px 35px 35px 35px;
      margin-left: 50px;
      outline: 0;
      border-width: 1px;
      border-color: #FF0085;
      background-color: #FF0085;
      color: #fff ;
      text-decoration: none;
      text-align: center;
      font-family: 'Montserrat Bold' !important;
  }
  .btnPildoraRigth:active,.btnPildoraRigth:hover{
    background-color: #fff !important;
    color: #FF0085 !important;
  }


  @media screen and (max-width:700px) {
    .landingButtons {
      padding-top: 17px;
    }
    .music{
      font-size: 70px !important;
    }
    .titleText{
      font-size: 35px;
      font-weight: bold;
      text-align: center;
      margin: 0px;
    }
    .Texto{
      font-family: 'Montserrat Bold';
      text-align: center;
      font-size: 18px;
      margin-bottom: 0px;
      margin-top: 0px;
      position: relative;
      top: 125px;
    }
    .Texto2{
      text-align: center;
      font-size: 22px;
      margin-top: 5px;
    }
    .buttonContainerLanding {
      position: relative;
      top: 115px;
      margin-top: 0;
      margin-bottom: 0;
    }
    .btnPildoraLeft{
      font-size: 20px;
      width: 140px;
      height: 20%;
      border-radius: 35px 35px 35px 35px;
      margin-right: 10px;
      outline: 0;
      border-width: 1px;
      border-color: #8600CF;
      background-color: #8600CF;
      color: #fff;
      outline-offset: 1px;
      text-decoration: none;
      overflow: hidden;
      text-align: center;


    }
    .btnPildoraRigth{
      font-size: 20px;
      width: 140px;
      height: 20%;
      border-radius: 35px 35px 35px 35px;
      margin-left: 10px;
      outline: 0;
      border-width: 1px;
      border-color: #FF0085;
      background-color: #FF0085;
      color: #fff ;
      text-decoration: none;
      text-align: center;
    }
    .h3 {
      margin: 0px;
      height: 45px;
    }
    .btnPildoraLeft:active,.btnPildoraLeft:hover{
      background-color: #fff !important;
      color: #8600CF !important;
    }
    .btnPildoraRigth:active,.btnPildoraRigth:hover{
      background-color: #fff !important;
      color: #FF0085 !important;
    }
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    background-color: $background-color;
    height: 100%;
  }

  a, button, input, select, textarea {
    font-family: 'Titillium Web';
  }

  #app-wrapper {
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
    background-color: $background-color;
    height: $main-height;
    width: 100vw;
  }

  .main {
    height: $main-height;
    width: 100vw;
  }

  ul {
    margin: 0;
  }

  .bg-primary {
    background-color: $primary-color;
  }

  .bg-secondary {
    background-color: $secondary-color;
  }

  .bg-accent {
    background-color: $accent-color;
  }

  .bg-tertiary{
    background-color: $background-color;
  }

  .primary {
    color: $primary-color;
  }

  .secondary {
    color: $secondary-color;
  }

  .textColor {
    color: $text-color;
  }

  .iconColor {
    color: $icon-color;
  }

  .accent {
    color: $accent-color;
  }

  .errorText {
    color: $error-color;
  }

  .btn {
    border: 0;
    box-sizing: border-box;
    line-height: 2;
    background-color: $primary-color;
    color: white;
  }

  .input {
    box-sizing: border-box;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #fff;
    background-color: $background-color;
    color: $text-color !important;
  }

  .error {
    border-bottom: 1px solid $error-color;
  }

  .total-height {
    height: $main-height
  }

  .background-center {
    background-position: center center;
  }

  .text-ellipsis {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vinyl-rotation {
    animation: 1.5s linear infinite rotation;
  }

  #style-scroll-bar::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 8px;
    background-color:  #555555;
  }

  #style-scroll-bar::-webkit-scrollbar
  {
    width: 8px;
    background-color: #555555;
  }

  #style-scroll-bar::-webkit-scrollbar-thumb
  {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: $secondary-color;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .w-35 {
    width: 35%;
  }

  .w-15 {
    width: 15%;
  }

  .w-7 {
    width: 7%;
  }

  .w-3 {
    width: 3%;
  }

  .w-5 {
    width: 5%;
  }

  .w-95 {
    width: 95%;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }

  ::placeholder {
    color: $text-color !important;
  }

  .v--modal {
    background-color: $background-color !important;
    color: #fff !important;
  }

  @media screen and (min-width: 1710px) {
    .Texto{
      font-family: 'Montserrat Bold';
      text-align: center;
      font-size: 20px;
      margin-bottom: 0px;
      margin-top: 290px;
      text-shadow: 5px 5px 5px #000;
    }
    .Texto2{
      font-size: 25px;
      margin-top: 0px;
      position: relative;
      top: -20px;
    }
  }

  @media screen and (min-width: 710px) and (max-width:1700px) {
    .mainTitle {
      position: relative;
      top: -20px;
    }
    .music{
      font-size: 50px !important;
    }
    .titleText{
      font-size: 35px;
      font-weight: bold;
      text-align: center;
      margin: 0px;
    }
    .Texto{
      font-family: Montserrat Bold;
      font-size: 20px;
      margin-top: 200px;
      text-shadow: 5px 5px 5px #000;
    }
    .Texto2{
      font-size: 25px;
      margin-top: 0px;
      position: relative;
      top: -20px;
    }
    .buttonContainerLanding {
      position: relative;
      top: 50px;
      margin-top: 0px;
      margin-bottom: 0px;
    }
    .btnPildoraLeft{
      padding-bottom: 5px;
      padding-top: 5;
      font-size: 20px;
      width: 140px;
      height: 20%;
      border-radius: 35px 35px 35px 35px;
      margin-right: 50px;
      outline: 0;
      border-width: 1px;
      border-color: #8600CF;
      background-color: #8600CF;
      color: #fff;
      outline-offset: 1px;
      text-decoration: none;
      overflow: hidden;
      text-align: center;
    }
    .btnPildoraRigth{
      padding-bottom: 5px;
      padding-top: 5px;
      font-size: 20px;
        width: 140px;
        height: 20%;
        border-radius: 35px 35px 35px 35px;
        margin-left: 50px;
        outline: 0;
        border-width: 1px;
        border-color: #FF0085;
        background-color: #FF0085;
        color: #fff ;
        text-decoration: none;
        text-align: center;
    }
    .h3 {
      margin: 0px;
      height: 45px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Landing/Landing.vue